<template>
  <div class="checkRegistration">
    <h1>Check Registration</h1>
    <div v-for="item in userInfos" :key="item.id">
      <h3>{{ item.userFirst }}</h3>
      <p>{{ item.userLast }}</p>
    </div>
    <FunctionalityHead />
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { listUserInfos } from "@/graphql/queries";
import FunctionalityHead from "@/components/FunctionalityHead.vue";

export default {
  name: "CheckRegistration",
  components: {
    FunctionalityHead
  },
  async created() {
    this.listUserInfos();
    //this.currentUserSub();
  },
  computed: {
    currentUserSub() {
      return this.$store.state.currentUser.currentUserSub;
    }
  },
  data() {
    return {
      userInfos: []
    };
  },
  methods: {
    async listUserInfos() {
      //this.userIncognitoSub = this.$store.state.currentUserSub;
      const userInfos = await API.graphql(
        graphqlOperation(listUserInfos, {
          filter: {
            userCognitoSub: {
              eq: this.currentUserSub
            }
          }
        })
      );
      this.userInfos = userInfos.data.listUserInfos.items;
      //this.regComplete = userInfos.regInitialized.length == 0; // || !userInfos.regInitialized;
      this.$store.commit(
        "changeCurrentUserRegInitialized",
        this.userInfos.regInitialized
      );
    }
  }
};
</script>
